var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('landing-create', {
    attrs: {
      "content": _vm.content
    }
  }), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm.attributes ? _c('view-component', {
    attrs: {
      "attributes": _vm.attributes
    },
    scopedSlots: _vm._u([{
      key: "multiple-codes-section",
      fn: function () {
        var _vm$projectCodeData, _vm$projectCodeData$a;

        return [_c('v-list-item-title', [(_vm$projectCodeData = _vm.projectCodeData) !== null && _vm$projectCodeData !== void 0 && (_vm$projectCodeData$a = _vm$projectCodeData.additionalProjectCodes) !== null && _vm$projectCodeData$a !== void 0 && _vm$projectCodeData$a.length ? _c('div', _vm._l(_vm.projectCodeData.additionalProjectCodes, function (item) {
          return _c('div', {
            key: item.id,
            staticClass: "title-text"
          }, [_vm._v(" " + _vm._s(item.alias) + " ")]);
        }), 0) : _c('div', [_vm._v(" N/A ")])]), _c('v-list-item-subtitle', [_c('p', {
          staticClass: "subtitle-text"
        }, [_vm._v("Project Code Alias")])])];
      },
      proxy: true
    }, {
      key: "multiple-ethics-section",
      fn: function () {
        var _vm$projectCodeData2, _vm$projectCodeData2$;

        return [(_vm$projectCodeData2 = _vm.projectCodeData) !== null && _vm$projectCodeData2 !== void 0 && (_vm$projectCodeData2$ = _vm$projectCodeData2.additionalEthicsNumbers) !== null && _vm$projectCodeData2$ !== void 0 && _vm$projectCodeData2$.length ? _c('div', [_c('v-list-item-title', [_c('v-row', {
          attrs: {
            "dense": ""
          }
        }, _vm._l(_vm.projectCodeData.additionalEthicsNumbers, function (item) {
          return _c('v-col', {
            key: item._id,
            staticClass: "mb-2",
            attrs: {
              "cols": "12"
            }
          }, [_c('v-card', {
            staticClass: "pa-2",
            attrs: {
              "outlined": "",
              "dense": ""
            }
          }, [_c('v-row', {
            staticClass: "added-ethics"
          }, [_c('v-col', {
            attrs: {
              "cols": "12",
              "sm": "4"
            }
          }, [_c('strong', [_vm._v(_vm._s(item.ethicsNumber))]), _c('p', [_vm._v("Number")])]), _c('v-col', {
            attrs: {
              "cols": "12",
              "sm": "4"
            }
          }, [_c('strong', [_vm._v(_vm._s(_vm.displayDate(item.ethicsDateApproved)))]), _c('p', [_vm._v("Approved")])]), _c('v-col', {
            attrs: {
              "cols": "12",
              "sm": "4"
            }
          }, [_c('strong', [_vm._v(_vm._s(_vm.displayDate(item.ethicsDateExpiration)))]), _c('p', [_vm._v("Expiration:")])])], 1)], 1)], 1);
        }), 1)], 1)], 1) : _c('div', [_c('v-list-item-title', [_vm._v("N/A")])], 1), _c('v-list-item-subtitle', [_c('p', {
          staticClass: "title-text"
        }, [_vm._v("Additional Ethics")])])];
      },
      proxy: true
    }], null, false, 3787539443)
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }